import type PaginatedListMeta from '@/types/PaginatedListMeta';

export const API_LIST_META: PaginatedListMeta = {
  current_page: 1,
  last_page: 1,
};
